// extracted by mini-css-extract-plugin
export var standaloneTable = "_hi-0";
export var standaloneTableWithBodyFill = "_hi-1";
export var withExtraHeader = "_hi-2";